import { useRecoilState } from 'recoil';
import { mapDataAtom } from '../lib/atoms';
import './App.css';
import { useEffect, useState } from 'react';
import HexMap from './HexMap';
import NavBar from './NavBar';
import InfoBox from './InfoBox';
import useLocal from '../lib/useLocal';
// import hexMap from '../hexMap.json';

const API = 'https://marcmajcher.github.io/vipers-elegy-data/hexMap.json'

function App() {
  const [mapData, setMapData] = useRecoilState(mapDataAtom);
  const [loaded, setLoaded] = useState(false);
  const [, setNextOpen] = useLocal('nextOpen');

  useEffect(() => {
    fetch(API).then(res => res.json()).then(hexMap => {
      setMapData(hexMap);
      setLoaded(true);
    })
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function resetFlipped() {
    setNextOpen(1);
  }

  return (
    <div className="app" >
      <span className="secret" onClick={() => resetFlipped()}>π</span>
      <h1>{mapData.name}</h1>
      {loaded ? <main>
        <HexMap hexMap={mapData} />
        <div className='info-box'>
          <NavBar />
          <InfoBox />
        </div>
      </main>
        : <h1 className='loading'>LOADING...</h1>}
    </div>
  );
}

export default App;
